module.exports = __webpack_public_path__ + "img/camp_shirt_other9.dd389ab5.svg";